import { GridSortModel } from '@mui/x-data-grid-pro';
import { ITaskSearchSortedColumn } from 'app/models/Tasks/Tasks';

/** Maps DataGrid field names to [amnone].[usp_FindTask] @SortedColumn display labels. */
export const GRID_FIELD_TO_SP_COLUMN: Record<string, string> = {
  status: 'Status',
  from: 'From',
  sentDate: 'Sent Date',
  isFollowup: 'Follow-Up',
  followupDate: 'Follow-Up Date',
  priority: 'Priority',
  isOptionApproval: 'Option Approval',
  category: 'Category',
  isFlagged: 'Flagged',
  isCoverage: 'Coverage',
  coveredFor: 'Coverage For',
  facilityID: 'Facility ID',
  facility: 'Facility',
  unitID: 'Unit ID',
  unit: 'Unit',
  orderID: 'Order ID',
  placementID: 'Placement ID',
  candidateID: 'Candidate ID',
  candidate: 'Candidate',
  contractAffiliateID: 'Contract Affiliate ID',
  affiliateContactID: 'Affiliate Contact ID',
  facilityContactID: 'Facility Contact ID',
};

const SP_COLUMN_TO_GRID_FIELD = Object.fromEntries(
  Object.entries(GRID_FIELD_TO_SP_COLUMN).map(([field, column]) => [column, field]),
);

export const NON_SERVER_SORTABLE_FIELDS = new Set(['recipients', 'message', 'subject']);

export const isServerSortableField = (field: string | undefined | null): boolean =>
  !!field && !NON_SERVER_SORTABLE_FIELDS.has(field) && field in GRID_FIELD_TO_SP_COLUMN;

export const toTaskSearchSortedColumn = (
  field: string,
  direction: 'asc' | 'desc' | string | null | undefined,
): ITaskSearchSortedColumn | undefined => {
  if (!isServerSortableField(field) || !direction) {
    return undefined;
  }

  const normalizedDirection = direction.toLowerCase() === 'asc' ? 'asc' : 'desc';

  return {
    column: GRID_FIELD_TO_SP_COLUMN[field],
    direction: normalizedDirection,
  };
};

export const toGridSortModel = (
  sortedColumn: ITaskSearchSortedColumn | undefined | null,
): GridSortModel => {
  if (!sortedColumn?.column || !sortedColumn?.direction) {
    return [];
  }

  const field = SP_COLUMN_TO_GRID_FIELD[sortedColumn.column];
  if (!field) {
    return [];
  }

  const direction = sortedColumn.direction.toLowerCase() === 'asc' ? 'asc' : 'desc';

  return [{ field, sort: direction }];
};

export const fromGridSortModel = (
  sortModel: GridSortModel | undefined | null,
): ITaskSearchSortedColumn | undefined => {
  const first = sortModel?.[0];
  if (!first?.field || !first?.sort) {
    return undefined;
  }

  return toTaskSearchSortedColumn(first.field, first.sort);
};
